import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "example fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex my-auto"
}
const _hoisted_2 = { class: "relative w-full lg:w-3/5 my-6 mx-2 lg:mx-auto container" }
const _hoisted_3 = { class: "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_4 = { class: "flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t" }
const _hoisted_5 = { class: "text-3xl font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none" }, " × ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "rounded-md p-6 mx-4 my-6" }
const _hoisted_10 = { class: "text-lg mb-4" }
const _hoisted_11 = { class: "flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.showError ? "ออเดอร์มีการเปลี่ยนแปลง" : "การยืนยันรายการ"), 1),
                _createElementVNode("button", {
                  class: "p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal()))
                }, _hoisted_7)
              ]),
              (_ctx.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.showError
                    ? 'ข้อมูลของออเดอร์มีการเปลี่ยนแปลง กรุณาโหลดหน้าใหม่ หรือ คลิกที่ปุ่ม "โหลดหน้าใหม่" เพื่อกรอกข้อมูลใหม่'
                    : "คุณต้องการยืนยันข้อมูลการจัดส่งใช่หรือไม่ ?"), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.showError)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "text-green-island-500 bg-gray-200 hover:bg-gray-300 active:bg-gray-300 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-4 mb-1 ease-linear transition-all duration-150",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal()))
                    }, " ยกเลิก "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(["text-gray-200 rounded-md bg-green-island-500 hover:bg-green-island-600 background-transparent font-bold uppercase px-6 py-3 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150", _ctx.saveDisabled ? 'opacity-25' : '']),
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showError ? _ctx.reload() : _ctx.btnOkClick())),
                  disabled: _ctx.saveDisabled
                }, _toDisplayString(_ctx.showError ? "โหลดหน้าใหม่" : "ยืนยัน"), 11, _hoisted_12)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
      : _createCommentVNode("", true)
  ]))
}